import { render, staticRenderFns } from "./DrawTest.vue?vue&type=template&id=260f3355"
import script from "./DrawTest.vue?vue&type=script&lang=js"
export * from "./DrawTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports